import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/builds/dlk/webshop-magento/frontend/src/dlk-giftcard/app/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/builds/dlk/webshop-magento/frontend/src/dlk/app/layouts/empty.vue").then(m => m.default || m)),
  checkout: defineAsyncComponent(() => import("/builds/dlk/webshop-magento/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/layouts/checkout.vue").then(m => m.default || m))
}